/**
 * Derive a Firebase Storage thumbnail URL from the stored photo URL.
 *
 * Firebase Resize Images extension produces variants with suffixes like:
 *   photo_1200x1200.webp  →  photo_200x200.webp
 *
 * If the URL doesn't match the expected pattern (e.g. external / no suffix)
 * the original URL is returned as a fallback.
 */
export const getThumbnailUrl = (url: string | undefined | null): string | null => {
  if (!url) return null;

  // Replace any _NNNxNNN. size suffix with _200x200.
  const thumbUrl = url.replace(/_\d+x\d+(\.[a-z]+)(\?|$)/i, "_200x200$1$2");

  // If nothing changed the URL didn't have a recognised suffix – return original.
  return thumbUrl !== url ? thumbUrl : url;
};
